import React from 'react';
import cx from 'classnames';
import './Button.css';

function Button({background, color = 'black', borderColor, className, children, ...otherProps}) {
  return (
    <button className={cx('ha-button', className)} style={{background, color, borderColor}} {...otherProps}>
      {children}
    </button>
  )
}
export default Button;
